var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 6.5L6.69335 6.48667C6.77884 6.44396 6.87477 6.42664 6.96979 6.43677C7.06482 6.4469 7.15495 6.48404 7.22951 6.54381C7.30408 6.60357 7.35995 6.68345 7.39053 6.77399C7.4211 6.86453 7.42509 6.96193 7.40202 7.05467L6.93002 8.94533C6.90678 9.03811 6.91064 9.13561 6.94114 9.22626C6.97165 9.31691 7.02751 9.39691 7.10211 9.45678C7.1767 9.51664 7.26691 9.55384 7.36201 9.56399C7.45712 9.57413 7.55314 9.55678 7.63868 9.514L7.66602 9.5M13.166 7C13.166 7.78793 13.0108 8.56815 12.7093 9.2961C12.4078 10.0241 11.9658 10.6855 11.4087 11.2426C10.8515 11.7998 10.1901 12.2417 9.46212 12.5433C8.73416 12.8448 7.95395 13 7.16602 13C6.37808 13 5.59787 12.8448 4.86992 12.5433C4.14196 12.2417 3.48053 11.7998 2.92337 11.2426C2.36622 10.6855 1.92427 10.0241 1.62274 9.2961C1.32121 8.56815 1.16602 7.78793 1.16602 7C1.16602 5.4087 1.79816 3.88258 2.92337 2.75736C4.04859 1.63214 5.57472 1 7.16602 1C8.75731 1 10.2834 1.63214 11.4087 2.75736C12.5339 3.88258 13.166 5.4087 13.166 7ZM7.16602 4.5H7.17135V4.50533H7.16602V4.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelper);
export default __webpack_public_path__ + "static/media/helper.226c33f9.svg";
export { ForwardRef as ReactComponent };